import * as z from "zod";

export const expenseFormSchema = z.object({
  description: z.string().min(1, "Description is required"),
  amount: z.string().min(1, "Amount is required"),
  category: z.string().min(1, "Category is required"),
  date: z.date(),
  paidBy: z.string().min(1, "Paid by is required"),
  participants: z.array(z.string()).optional()
});

export type ExpenseFormValues = z.infer<typeof expenseFormSchema>;